import { render } from "./UserImageGallery.vue?vue&type=template&id=2604449f&scoped=true&lang=pug"
import script from "./UserImageGallery.vue?vue&type=script&lang=js"
export * from "./UserImageGallery.vue?vue&type=script&lang=js"

import "./UserImageGallery.vue?vue&type=style&index=0&id=2604449f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2604449f"]])

export default __exports__